import Helper from './Helper';

class TeaserHandler {
  constructor(config = {}) {
    const {
      header,
      teaserContainer,
      teaserLink,
      ratioMin,
      ratioMax
    } = config;

    this.teaserContainer = document.querySelector(teaserContainer);

    this.teaserLink = document.querySelectorAll(teaserLink);
    this.teaserLinkArray = Array.prototype.slice.call(this.teaserLink);

    if(document.querySelector(header)){
      this.headerHeight = document.querySelector(header).clientHeight;
    }
    this.ratioMin = ratioMin;
    this.ratioMax = ratioMax;

    if (this.teaserContainer) {
      this.bindEvents();
      this.addClassOnTeaserContainer(this.teaserContainer);
    }
  }

  /*
  * @
  * */
  bindEvents() {
    window.addEventListener('resize', () => {
      this.toggleClassOnEachTeaserLink();
      this.addHeightOnTeaserContainer();
    });

    window.addEventListener('load', () => {
      this.toggleClassOnEachTeaserLink();
      this.addHeightOnTeaserContainer();
    });

    window.addEventListener("orientationchange", () => {
      this.toggleClassOnEachTeaserLink();
      this.addHeightOnTeaserContainer();
    });
  }

  /**
   *
   */
  toggleClassOnEachTeaserLink() {
    this.teaserLinkArray.forEach(linkItem => {
      this.toggleClassOnTeaserLink(linkItem);
    });
  }

  /**
   *
   * @param item is this.teaserLinkArray
   */
  toggleClassOnTeaserLink(item) {
    if (this.isRatio()) {
      Helper.addClass(item, 'teaser__link--js');
    } else  {
      Helper.removeClass(item, 'teaser__link--js');
    }
  }

  /**
   *
   * @param item is this.teaserContainer
   */
  addClassOnTeaserContainer(item) {
    Helper.addClass(item, 'teaser--js-loaded');
  }

  addHeightOnTeaserContainer() {
    Helper.addClass(this.teaserContainer, 'teaser--js-load');

    if (this.isRatio()) {
      this.teaserContainer.style.height = (window.outerHeight - this.headerHeight) + 'px';
    } else {
      this.teaserContainer.style.height = 'auto';
    }
  }

  /*
  * isRatio() returns true if ratio is given
  * */
  isRatio() {
    const ratio = window.outerWidth / window.outerHeight;
    if (ratio >= this.ratioMin && ratio <= this.ratioMax) {
      if(window.innerWidth >= 768){
        return true;
      }
    }
  }
}

export default TeaserHandler;
